import { render, staticRenderFns } from "./orderTracking.vue?vue&type=template&id=9f483f72&scoped=true&"
import script from "./orderTracking.vue?vue&type=script&lang=ts&"
export * from "./orderTracking.vue?vue&type=script&lang=ts&"
import style0 from "./orderTracking.vue?vue&type=style&index=0&id=9f483f72&lang=less&scoped=true&"
import style1 from "./orderTracking.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f483f72",
  null
  
)

export default component.exports